// import React from 'react';
// import './AboutPage.css';
// import graduationImg from '../Images/graduation.jpeg'; // Replace with your local image asset path
// import Navbar from './Navbar';
// import FooterSection from './FooterSection';
// import { Link } from 'react-router-dom';

// export default function AboutPage() {
//   const stats = [
//     { label: 'Active Students', value: '85,000+', icon: '👥' },
//     { label: 'Study Centres', value: '280+', icon: '🏢' },
//     { label: 'Programs', value: '42+', icon: '📖' },
//     { label: 'Years Excellence', value: '46+', icon: '🏅' }
//   ];

//   const objectives = [
//     "Provide quality higher education to the disadvantaged and working population through the flexible mode of distance education",
//     "Enable learners to acquire knowledge, skills, and competencies relevant to national development",
//     "Promote self-learning capabilities among students using modern pedagogical tools",
//     "Offer a wide range of UG, PG, Diploma, and Certificate programs at affordable fees",
//     "Establish and maintain a network of study centres across Tamil Nadu and other states",
//     "Foster research, innovation, and academic excellence within the distance education framework"
//   ];

//   const accreditations = [
//     { title: 'NAAC', grade: 'A++ Grade', desc: 'National Assessment & Accreditation Council' },
//     { title: 'UGC', grade: 'Recognized', desc: 'University Grants Commission' },
//     { title: 'AICTE', grade: 'Approved', desc: 'All India Council for Technical Education' },
//     { title: 'NIRF', grade: 'Ranked', desc: 'National Institutional Ranking Framework' }
//   ];

//   const milestones = [
//     { year: '1979', text: 'EDULEARNER established by the Government.' },
//     { year: '1985', text: 'Centre for Distance Education (CDE) launched to expand access to higher education' },
//     { year: '1995', text: 'NAAC accreditation obtained; programs expanded to include professional courses' },
//     { year: '2005', text: 'Digital learning initiatives introduced; e-content portal launched' },
//     { year: '2015', text: 'NAAC A++ Grade awarded; student count crosses 50,000' },
//     { year: '2020', text: 'Online Education wing added; renamed Centre for Distance and Online Education (CDOE)' },
//     { year: '2025', text: '85,000+ students, 280+ study centres, 42+ programs across India' }
//   ];

//   return (

//     <>
//           <Navbar />
//     <div className="about-page-wrapper">
      
//       {/* 1. Header Banner */}
//       <section className="about-hero-banner">
//         <div className="inner-banner-container">
//         <nav className="breadcrumb-nav">
//   <Link to="/" className="breadcrumb-link">Home</Link> / <span>About CDOE</span>
// </nav>
//           <h1>About CDOE</h1>
//           <p>Centre for Distance and Online Education, EDULEARNER — pioneering accessible quality education since 1985.</p>
//         </div>
//       </section>

//       {/* 2. Legacy Information & Stats Section */}
//       <section className="legacy-section">
//         <div className="about-page-container grid-2col">
//           <div className="legacy-content-left">
//             <span className="section-mini-tag">OUR INSTITUTION</span>
//             <h2>EDULEARNER – A Legacy of Excellence</h2>
//             <p>EDULEARNER, established in 1985, is a premier institution located in India. The institution is recognized for providing accessible, high-quality learning environments to students coming from all backgrounds.</p>
//             <p>The Centre for Distance and Online Education (CDOE) was established to provide quality higher education to students across India who cannot attend regular colleges due to work, family, or geographical constraints. Today, CDOE is one of the largest distance education centres.</p>
            
//             <div className="mini-stats-grid">
//               {stats.map((stat, i) => (
//                 <div key={i} className="mini-stat-card">
//                   <span className="m-stat-icon">{stat.icon}</span>
//                   <h3>{stat.value}</h3>
//                   <p>{stat.label}</p>
//                 </div>
//               ))}
//             </div>
//           </div>

//           <div className="legacy-graphic-right">
//             <div className="graphic-img-container">
//               <img src={graduationImg} alt="Graduation Celebration" />
//               <div className="floating-est-badge">
//                 <h4>Est. 1985</h4>
//                 <p>CDOE Founded</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* 3. Core Pillars: Vision, Mission, Quality */}
//       <section className="pillars-section">
//         <div className="about-page-container grid-3col">
//           <div className="pillar-card">
//             <div className="pillar-icon-box v-icon">🎯</div>
//             <h3>Our Vision</h3>
//             <p>To be a premier centre for distance and online education that fosters academic excellence, professional competence, and holistic development among learners across India and beyond.</p>
//           </div>
//           <div className="pillar-card">
//             <div className="pillar-icon-box m-icon">✨</div>
//             <h3>Our Mission</h3>
//             <p>To provide accessible, affordable, and quality higher education to all sections of society through innovative distance learning methods, digital technologies, and a wide network of study centres.</p>
//           </div>
//           <div className="pillar-card">
//             <div className="pillar-icon-box q-icon">🛡️</div>
//             <h3>Quality Policy</h3>
//             <p>CDOE is committed to continuously improving the quality of education delivery, student support services, and academic outcomes in alignment with national educational standards and UGC guidelines.</p>
//           </div>
//         </div>
//       </section>

//       {/* 4. Objectives Check Grid */}
//       <section className="objectives-section">
//         <div className="about-page-container">
//           <div className="centered-header">
//             <span className="section-mini-tag">OUR GOALS</span>
//             <h2>Objectives of CDOE</h2>
//           </div>
//           <div className="objectives-grid">
//             {objectives.map((obj, i) => (
//               <div key={i} className="obj-row-card">
//                 <span className="obj-check">✓</span>
//                 <p>{obj}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* 5. Recognition & Accreditation Panel */}
//       <section className="accreditation-panel">
//         <div className="about-page-container">
//           <div className="centered-header text-white">
//             <h2>Recognition &amp; Accreditation</h2>
//             <p>EDULEARNER is recognized by leading national bodies</p>
//           </div>
//           <div className="accreditation-grid">
//             {accreditations.map((acc, i) => (
//               <div key={i} className="acc-box-card">
//                 <h3>{acc.title}</h3>
//                 <h4>{acc.grade}</h4>
//                 <p>{acc.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* 6. History & Milestones Timeline */}
//       <section className="timeline-section">
//         <div className="about-page-container">
//           <div className="centered-header">
//             <span className="section-mini-tag">OUR JOURNEY</span>
//             <h2>History &amp; Milestones</h2>
//           </div>
//           <div className="timeline-track">
//             {milestones.map((milestone, i) => (
//               <div key={i} className="timeline-node-row">
//                 <div className="node-year-bubble">{milestone.year}</div>
//                 <div className="node-content-text">
//                   <p>{milestone.text}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//     </div>
//     <FooterSection/>
//     </>
//   );
// }

import React, { useState, useEffect } from 'react';
import './AboutPage.css';
import graduationImg from '../Images/graduation.jpeg';
import Navbar from './Navbar';
import FooterSection from './FooterSection';
import { Link } from 'react-router-dom';

export default function AboutPage() {
  // Default static fallback state
  const [stats, setStats] = useState([
    { label: 'Active Students', value: '85,000+', icon: '👥' },
    { label: 'Universities', value: '3+', icon: '🏢' },
    { label: 'Programs Offered', value: '13+', icon: '📖' },
    { label: 'Years Excellence', value: '46+', icon: '🏅' }
  ]);

  const objectives = [
    "Provide quality higher education to the disadvantaged and working population through the flexible mode of distance education",
    "Enable learners to acquire knowledge, skills, and competencies relevant to national development",
    "Promote self-learning capabilities among students using modern pedagogical tools",
    "Offer a wide range of UG, PG, Diploma, and Certificate programs at affordable fees",
    "Establish and maintain a network of study centres across Tamil Nadu and other states",
    "Foster research, innovation, and academic excellence within the distance education framework"
  ];

  const accreditations = [
    { title: 'NAAC', grade: 'A++ Grade', desc: 'National Assessment & Accreditation Council' },
    { title: 'UGC', grade: 'Recognized', desc: 'University Grants Commission' },
    { title: 'AICTE', grade: 'Approved', desc: 'All India Council for Technical Education' },
    { title: 'NIRF', grade: 'Ranked', desc: 'National Institutional Ranking Framework' }
  ];

  const milestones = [
    { year: '1979', text: 'EDULEARNER established by the Government.' },
    { year: '1985', text: 'Centre for Distance Education (CDE) launched to expand access to higher education' },
    { year: '1995', text: 'NAAC accreditation obtained; programs expanded to include professional courses' },
    { year: '2005', text: 'Digital learning initiatives introduced; e-content portal launched' },
    { year: '2015', text: 'NAAC A++ Grade awarded; student count crosses 50,000' },
    { year: '2020', text: 'Online Education wing added; renamed Centre for Distance and Online Education (CDOE)' },
    { year: '2026', text: 'Expanded network with active university partnerships and digital course portals across India' }
  ];

  // Fetch dynamic stats from dashboard API
  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await fetch('https://metapi.emedhatechnologies.com/api/courses/dashboard-stats');
        const result = await response.json();

        if (result.success && Array.isArray(result.data)) {
          const dynamicStatsMap = {};
          result.data.forEach((item) => {
            dynamicStatsMap[item.title.toLowerCase()] = item.value;
          });

          setStats([
            {
              label: 'Active Students',
              value: dynamicStatsMap['students'] ? `${dynamicStatsMap['students']}+` : '85,000+',
              icon: '👥'
            },
            {
              label: 'Universities',
              value: dynamicStatsMap['universities'] ? `${dynamicStatsMap['universities']}+` : '3+',
              icon: '🏢'
            },
            {
              label: 'Programs Offered',
              value: dynamicStatsMap['courses'] ? `${dynamicStatsMap['courses']}+` : '13+',
              icon: '📖'
            },
            {
              label: 'Years Excellence',
              value: '46+',
              icon: '🏅'
            }
          ]);
        }
      } catch (error) {
        console.error('Error fetching about page dynamic stats:', error);
      }
    };

    fetchStats();
  }, []);

  return (
    <>
      <Navbar />
      <div className="about-page-wrapper">
        
        {/* 1. Header Banner */}
        <section className="about-hero-banner">
          <div className="inner-banner-container">
            <nav className="breadcrumb-nav">
              <Link to="/" className="breadcrumb-link">Home</Link> / <span>About CDOE</span>
            </nav>
            <h1>About CDOE</h1>
            <p>Centre for Distance and Online Education, EDULEARNER — pioneering accessible quality education since 1985.</p>
          </div>
        </section>

        {/* 2. Legacy Information & Stats Section */}
        <section className="legacy-section">
          <div className="about-page-container grid-2col">
            <div className="legacy-content-left">
              <span className="section-mini-tag">OUR INSTITUTION</span>
              <h2>EDULEARNER – A Legacy of Excellence</h2>
              <p>EDULEARNER, established in 1985, is a premier institution located in India. The institution is recognized for providing accessible, high-quality learning environments to students coming from all backgrounds.</p>
              <p>The Centre for Distance and Online Education (CDOE) was established to provide quality higher education to students across India who cannot attend regular colleges due to work, family, or geographical constraints. Today, CDOE is one of the largest distance education centres.</p>
              
              <div className="mini-stats-grid">
                {stats.map((stat, i) => (
                  <div key={i} className="mini-stat-card">
                    <span className="m-stat-icon">{stat.icon}</span>
                    <h3>{stat.value}</h3>
                    <p>{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="legacy-graphic-right">
              <div className="graphic-img-container">
                <img src={graduationImg} alt="Graduation Celebration" />
                <div className="floating-est-badge">
                  <h4>Est. 1985</h4>
                  <p>CDOE Founded</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 3. Core Pillars: Vision, Mission, Quality */}
        <section className="pillars-section">
          <div className="about-page-container grid-3col">
            <div className="pillar-card">
              <div className="pillar-icon-box v-icon">🎯</div>
              <h3>Our Vision</h3>
              <p>To be a premier centre for distance and online education that fosters academic excellence, professional competence, and holistic development among learners across India and beyond.</p>
            </div>
            <div className="pillar-card">
              <div className="pillar-icon-box m-icon">✨</div>
              <h3>Our Mission</h3>
              <p>To provide accessible, affordable, and quality higher education to all sections of society through innovative distance learning methods, digital technologies, and a wide network of study centres.</p>
            </div>
            <div className="pillar-card">
              <div className="pillar-icon-box q-icon">🛡️</div>
              <h3>Quality Policy</h3>
              <p>CDOE is committed to continuously improving the quality of education delivery, student support services, and academic outcomes in alignment with national educational standards and UGC guidelines.</p>
            </div>
          </div>
        </section>

        {/* 4. Objectives Check Grid */}
        <section className="objectives-section">
          <div className="about-page-container">
            <div className="centered-header">
              <span className="section-mini-tag">OUR GOALS</span>
              <h2>Objectives of CDOE</h2>
            </div>
            <div className="objectives-grid">
              {objectives.map((obj, i) => (
                <div key={i} className="obj-row-card">
                  <span className="obj-check">✓</span>
                  <p>{obj}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 5. Recognition & Accreditation Panel */}
        <section className="accreditation-panel">
          <div className="about-page-container">
            <div className="centered-header text-white">
              <h2>Recognition &amp; Accreditation</h2>
              <p>EDULEARNER is recognized by leading national bodies</p>
            </div>
            <div className="accreditation-grid">
              {accreditations.map((acc, i) => (
                <div key={i} className="acc-box-card">
                  <h3>{acc.title}</h3>
                  <h4>{acc.grade}</h4>
                  <p>{acc.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 6. History & Milestones Timeline */}
        <section className="timeline-section">
          <div className="about-page-container">
            <div className="centered-header">
              <span className="section-mini-tag">OUR JOURNEY</span>
              <h2>History &amp; Milestones</h2>
            </div>
            <div className="timeline-track">
              {milestones.map((milestone, i) => (
                <div key={i} className="timeline-node-row">
                  <div className="node-year-bubble">{milestone.year}</div>
                  <div className="node-content-text">
                    <p>{milestone.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

      </div>
      <FooterSection />
    </>
  );
}